<!-- Basic search -->
<ng-container *ngIf="appearance === 'basic'">
    <div class="w-full sm:min-w-80">
      <!-- sss -->
      <mat-form-field class="w-full"  [ngClass]="class" [disabled]="disabled">
        <mat-icon *ngIf="icon" matPrefix [svgIcon]="icon"></mat-icon>
        <input matInput [formControl]="searchControl" [matAutocomplete]="matAutocomplete" [placeholder]="placeHolder"
          (keydown)="onKeydown($event)">
      </mat-form-field>
        <mat-autocomplete
            class="max-h-128 rounded"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            (optionSelected) = "selectedOption($event.option.value)"
            [displayWith]="displayDinamicKeySearch"
            #matAutocomplete="matAutocomplete">
            <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="resultSets && !resultSets.length">
                No se encontraron resultados!
            </mat-option>
             <ng-container *ngFor="let result of resultSets; trackBy: trackByFn">
                    <mat-option
                        aclass="group relative mb-1 py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        [value]="result"
                        >
                        <ng-container>
                            <ng-container *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                    </mat-option>
                </ng-container>
        </mat-autocomplete>
    </div>
</ng-container>

<!-- Dashboard search search -->
<ng-container *ngIf="appearance === 'dashboard'">
    <div class="w-full sm:min-w-110">
      <!-- sss -->
      <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-60 mr-4" >
        <mat-icon *ngIf="icon" matPrefix [svgIcon]="icon"></mat-icon>
        <input matInput [formControl]="searchControl" [matAutocomplete]="matAutocomplete" [placeholder]="placeHolder"
          (keydown)="onKeydown($event)"
          (input)="onChange($event.target.value)">
      </mat-form-field>
        <mat-autocomplete
            class="max-h-200 rounded"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            [disabled]="disabled"
            (optionSelected) = "selectedOption($event.option.value)"
            [displayWith]="displayDinamicKeySearch"
            #matAutocomplete="matAutocomplete"
            (change)="onChange($event)">
            <mat-option
                class="py-0 px-6 text-sm pointer-events-none text-secondary bg-transparent"
                *ngIf="resultSets && !resultSets.length">
                No se encontraron resultados!
            </mat-option>
             <ng-container *ngFor="let result of resultSets; trackBy: trackByFn">
                    <mat-option
                        aclass="group relative mb-1 py-0 px-6 text-sm rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        [value]="result"
                        >
                        <ng-container>
                            <ng-container *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                    </mat-option>
                </ng-container>
        </mat-autocomplete>
    </div>
</ng-container>

<!-- Dashboard search search -->
<ng-container *ngIf="appearance === 'outline'">
      <!-- sss -->
      <mat-form-field appearance="outline" class="w-full mt-1">
        <mat-icon *ngIf="icon" matPrefix [svgIcon]="icon"></mat-icon>
        <input matInput [formControl]="searchControl"
                [matAutocomplete]="matAutocomplete"
                [placeholder]="placeHolder"
                class="border border-gray-300 rounded-md w-full"
          (keydown)="onKeydown($event)"
          (input)="onChange($event.target.value)">
      </mat-form-field>
        <mat-autocomplete
            class="max-h-200 rounded"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            (optionSelected) = "selectedOption($event.option.value)"
            [displayWith]="displayDinamicKeySearch"
            #matAutocomplete="matAutocomplete"
            (change)="onChange($event)">
            <mat-option
                class="py-0 px-6 text-sm pointer-events-none text-secondary bg-transparent"
                *ngIf="resultSets && !resultSets.length">
                No se encontraron resultados!
            </mat-option>
             <ng-container *ngFor="let result of resultSets; trackBy: trackByFn">
                    <mat-option
                        aclass="group relative mb-1 py-0 px-6 text-sm rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        [value]="result"
                        >
                        <ng-container>
                            <ng-container *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                    </mat-option>
                </ng-container>
        </mat-autocomplete>
</ng-container>

<!-- Person result template -->
<ng-template
    #contactResult
    let-result>
    <div class="flex items-center">
        <div class="ml-3 truncate">
            <span [innerHTML]="displayDinamicKeySearch(result, displayInformation)"></span>
        </div>
    </div>
</ng-template>

<!-- Person result template -->
<ng-template
    #taskResult
    let-result>
    <div class="flex items-center">
        <div class="ml-3 truncate">
            <span [innerHTML]="displayDinamicKeySearch(result)"></span>
        </div>
    </div>
</ng-template>

